export default {
	title: "VIP-nivå",
	current: "Aktuell VIP-nivå",
	status: {
		btn: ["Aktiverad", "Registrera dig nu"]
	}
};
